import { useFormContext } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';

import { Input, Date, Country } from '@/components/fields';
import { useTheme } from '@/contexts/ThemeContext';

export default function SecurityDetails(): JSX.Element {
  const { watch } = useFormContext();
  const {
    state: {
      form: { nin },
    },
  } = useStateMachine();
  const formType = watch('form_type');

  const { landingPage } = useTheme();

  return (
    <>
      <div>
        {landingPage !== 'v12' && landingPage !== 'v13' && (
          <h3 className="bg-box-header text-xl leading-8 font-medium tracking-tight text-white flex items-center mb-5 py-2 px-4">
            Security Details
          </h3>
        )}
        <div className="px-6 py-1">
          <div>
            <Input id="passport_number" isRequired={false}>
              <span className="font-normal">
                Passport Number <sup className="text-red-600 font-sans">*</sup>
              </span>
              <br />
              <span className="font-medium text-xs text-red-600 inline-block leading-4">
                Please enter your UK passport number below. You will be giving
                your consent to access your personal data (including your photo
                and signature) held by the Identity and Passport Service (IPS).
                The information returned from IPS will be used to check your
                identity.
              </span>
            </Input>
            {['renewal', 'exchange'].includes(formType) && (
              <>
                <Date
                  id="passport_expiry_date"
                  type="future"
                  skipYears={0}
                  isRequired
                >
                  Passport Expiry Date
                </Date>
                <Country id="passport_issue_country" isRequired>
                  Passport Issuance Country
                </Country>
              </>
            )}
            {!nin && (
              <div className="mt-8">
                <Input id="ni_number" isRequired={false}>
                  <span className="font-normal">
                    National Insurance Number{' '}
                    <sup className="text-red-600 font-sans">*</sup>
                  </span>
                  <br />
                  <span className="font-medium text-xs text-red-600 inline-block leading-4">
                    By providing your national insurance number, you are
                    allowing it to be used by the DVLA to verify your identity.
                    This is not mandatory, however, if you do not provide your
                    national insurance number, it may delay your application and
                    you may be required to verify your identity to the DVLA via
                    post.
                  </span>
                </Input>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
